import {useQuery} from "@apollo/client";
import {GetAdministratorSelf} from "./Admin.js";

export function useGetAdministratorSelf(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetAdministratorSelf,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetAdministratorSelf']) ? data : previousData;
    const extracted = (holder) ? holder['GetAdministratorSelf'] : null;

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetAdministratorSelf(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetAdministratorSelf,
        variables
    });
    const extracted = data ? data['GetAdministratorSelf'] : null;
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
